import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, Loader } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { fields } from "../constants";
import { useCPOsOffice } from "../ContactDirectory.hook";

export const CPOsOffice = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editGallery,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditGallery,
  } = useCPOsOffice();

  const {
    data: GalleryById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(()=>{
    if(!query.get("id")){
        refetchEditGallery();
    }
  },[])

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
  }, [query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
     field_cpo_name_en: GalleryById
        ? decodeHTML(GalleryById.payload.field_cpo_name_en)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_cpo_name_en)
          : "",
    field_cpo_name_ms: GalleryById ? decodeHTML(GalleryById.payload.field_cpo_name_ms) : editGallery ? decodeHTML(editGallery?.[0]?.field_cpo_name_ms) : "",
    field_cpo_name_zh: GalleryById
        ? decodeHTML(GalleryById.payload.field_cpo_name_zh)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_cpo_name_zh)
          : "",
    field_cpo_designation_en: GalleryById
        ? decodeHTML(GalleryById.payload.field_cpo_designation_en)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_cpo_designation_en)
          : "",
    field_cpo_designation_ms: GalleryById
        ? decodeHTML(GalleryById.payload.field_cpo_designation_ms)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_cpo_designation_ms)
          : "",
    field_cpo_designation_zh: GalleryById
        ? decodeHTML(GalleryById.payload.field_cpo_designation_zh)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_cpo_designation_zh)
          : "",
    field_department: GalleryById
          ? decodeHTML(GalleryById.payload.field_department)
          : editGallery
            ? decodeHTML(editGallery?.[0]?.field_department)
            : "",
    field_cpo_email: GalleryById
          ? decodeHTML(GalleryById.payload.field_cpo_email)
          : editGallery
            ? decodeHTML(editGallery?.[0]?.field_cpo_email)
            : "",
    field_cpo_phone_number: GalleryById
          ? decodeHTML(GalleryById.payload.field_cpo_phone_number)
          : editGallery
            ? decodeHTML(editGallery?.[0]?.field_cpo_phone_number)
            : "",
    field_cpopage_published: GalleryById ? GalleryById.payload.field_cpopage_published : editGallery ? editGallery?.[0]?.field_cpopage_published : "",
    },
    fields: fields.CposOffice,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Contact Directory",
      subModule: "CposOffice",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
           `${magpHost}/api/cpo-contact-directory-creation${(editGallery?.[0]?.id || GalleryById?.payload?.id) ? `/${editGallery?.[0]?.id || GalleryById?.payload?.id}` : ""}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }        
      />
  );
};
